<template>
    <var-app-bar class="top-header-body" title-position="center" :title="$t(route.meta.title as string)">
        <template #left>
            <VarButton v-if="!route.meta.noBack" color="transparent" text-color="#fff" text @click="GoBack">
                <VarIcon name="chevron-left" size="24" />
            </VarButton>
            <VarSpace v-else size="5px" style="margin-left: 10px;">
                <VarImage fit="cover" radius="50%" :src="$R(systemConfigStore.getConfig?.SystemLogo)" height="24"></VarImage>
                <span>{{ systemConfigStore.config?.SystemName }}</span>
            </VarSpace>
        </template>
        <template #right>
            <ClockComponent style="font-size: 12px;"></ClockComponent>
            <var-button color="transparent" text-color="#fff" round text>
                <var-icon v-if="themeStore.getThemeName == 'dark'" namespace="icon" @click="SetTheme('light')"
                    name="yejing" :size="20" />
                <var-icon v-else namespace="icon" @click="SetTheme('dark')" name="lieri" :size="20" />
            </var-button>
            <var-menu v-model:show="languageStatusStore.show" placement="bottom-end">
                <var-button color="transparent" text-color="#fff" round text>
                    <var-icon namespace="icon" name="duoyuyan" :size="24" />
                </var-button>

                <template #menu>
                    <LanguageComponent></LanguageComponent>
                    <!-- <var-cell @click="SetLocale(key)" v-for="(v, key) in messages" ripple>{{ key }}</var-cell> -->
                </template>
            </var-menu>
        </template>
    </var-app-bar>
</template>
<script setup lang="ts">
import router from '@/router';
import { useLocaleStore } from '@/store/locale';
import { useSystemConfigStore } from '@/store/SystemConfigStore';
import { useThemeStore } from '@/store/theme';
import { Locale, Themes } from '@varlet/ui';
import { useRoute } from 'vue-router';
import LanguageComponent from '../GlobalComponents/LanguageComponent.vue';
import { useLanguageStatusStore } from '@/store/LanguageStatusStore';
import ClockComponent from '../GlobalComponents/ClockComponent.vue';
const route = useRoute();
const locale = useLocaleStore();
const themeStore = useThemeStore();
const systemConfigStore = useSystemConfigStore();
const languageStatusStore = useLanguageStatusStore();
const messages = Locale.messages;

function SetTheme(themeKey: 'light' | 'dark') {
    themeStore.setTheme(themeKey);
}

/**
 * 返回
 */
function GoBack() {
    router.back();
}
</script>

<style lang="scss">
.top-header-body {
    // position: sticky;
    // top: 0px;
    box-shadow: 0px 1px 1px 0px rgba(113, 92, 252, 0.25);
    backdrop-filter: blur(10px);
}
</style>